<template>
  <div class="process">
    <div class="title">{{$t('meg.process')}}</div>
    <p style="font-size: .175rem;color: #818AA0;line-height: .1875rem;">Platform Operation Process</p>
    <div class="proMain">
      <div class="leftPro">
        <li @click="liBtn(1)" :class="{ active: livalue === 1 }">
          <span class="Num">01</span>
          <span class="NumText">平台预览</span>
          <!-- <span class="NumText">Platform Preview</span> -->
        </li>
        <span style="width: .5125rem;height: 0rem;opacity: 1;border: .025rem dashed #818AA0;margin-top: .3875rem;"></span>
        <li @click="liBtn(2)" :class="{ active: livalue === 2 }">
          <span class="Num">02</span>
          <span class="NumText">用户注册</span>
        </li>
        <span style="width: .5125rem;height: 0px;opacity: 1;border: .025rem dashed #818AA0;margin-top: .3875rem;"></span>
        <li @click="liBtn(3)" :class="{ active: livalue === 3 }">
          <span class="Num">03</span>
          <span class="NumText">用户登录</span>
        </li>
        <div style="width: 0rem;height: .5rem;opacity: 1;border: .025rem dashed #818AA0;position: absolute;right: 1.125rem;top: 1.3875rem;"></div>
        <div style="width: 0rem;height: .5rem;opacity: 1;border: .025rem dashed #818AA0;position: absolute;left: .6375rem;bottom: 2.35rem;"></div>
        <li @click="liBtn(6)" :class="{ active: livalue === 6 }">
          <span class="Num">06</span>
          <span class="NumText">正式下单</span>
        </li>
        <span style="width: .5125rem;height: 0rem;opacity: 1;border: .025rem dashed #818AA0;margin-top: .3875rem;"></span>
        <li @click="liBtn(5)" :class="{ active: livalue === 5 }">
          <span class="Num">05</span>
          <span class="NumText">人工服务</span>
        </li>
        <span style="width: .5125rem;height: 0rem;opacity: 1;border: .025rem dashed #818AA0;margin-top: .3875rem;"></span>
        <li @click="liBtn(4)" :class="{ active: livalue === 4 }">
          <span class="Num">04</span>
          <span class="NumText">意向下单</span>
        </li>
        <li @click="liBtn(7)" :class="{ active: livalue === 7 }">
          <span class="Num">07</span>
          <span class="NumText">分配工厂</span>
        </li>
        <span style="width: .5125rem;height: 0rem;opacity: 1;border: .025rem dashed #818AA0;margin-top: .3875rem;"></span>
        <li @click="liBtn(8)" :class="{ active: livalue === 8 }">
          <span class="Num">08</span>
          <span class="NumText">订单生产</span>
        </li>
        <span style="width: .5125rem;height: 0px;opacity: 1;border: .025rem dashed #818AA0;margin-top: .3875rem;"></span>
        <li @click="liBtn(9)" :class="{ active: livalue === 9 }">
          <span class="Num">09</span>
          <span class="NumText">完成订单</span>
        </li>
      </div>
      <div class="rightBox">
        <div class="leftRight" style="text-align: left;" v-if="livalue === 1">
          <h1 style="font-size: .6rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 800;color: #002FA7;margin-left: .7125rem;margin-top: .4rem;">01</h1>
          <h1 style="font-size: .375rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #000000;margin-left: .7125rem;margin-top: .775rem;">平台浏览</h1>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>浏览平台内容</span>
          </li>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>了解平台功能</span>
          </li>
        </div>
        <div class="leftRight" style="text-align: left;" v-if="livalue === 2">
          <h1 style="font-size: .6rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 800;color: #002FA7;margin-left: .7125rem;margin-top: .4rem;">02</h1>
          <h1 style="font-size: .375rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #000000;margin-left: .7125rem;margin-top: .775rem;">用户注册</h1>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>填报注册信息</span>
          </li>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>邮箱验证，快速注册</span>
          </li>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>完善信息，平台审核</span>
          </li>
        </div>
        <div class="leftRight" style="text-align: left;" v-if="livalue === 3">
          <h1 style="font-size: .6rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 800;color: #002FA7;margin-left: .7125rem;margin-top: .4rem;">03</h1>
          <h1 style="font-size: .375rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #000000;margin-left: .7125rem;margin-top: .775rem;">用户登录</h1>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>入驻平台</span>
          </li>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>获取操作权限</span>
          </li>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>平台服务体验</span>
          </li>
        </div>
        <div class="leftRight" style="text-align: left;" v-if="livalue === 4">
          <h1 style="font-size: .6rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 800;color: #002FA7;margin-left: .7125rem;margin-top: .4rem;">04</h1>
          <h1 style="font-size: .375rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #000000;margin-left: .7125rem;margin-top: .775rem;">意向下单</h1>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>意向单信息填报</span>
          </li>
        </div>
        <div class="leftRight" style="text-align: left;" v-if="livalue === 5">
          <h1 style="font-size: .6rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 800;color: #002FA7;margin-left: .7125rem;margin-top: .4rem;">05</h1>
          <h1 style="font-size: .375rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #000000;margin-left: .7125rem;margin-top: .775rem;">人工服务</h1>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>承接意向单</span>
          </li>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>专人服务</span>
          </li>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>详细信息确认</span>
          </li>
        </div>
        <div class="leftRight" style="text-align: left;" v-if="livalue === 6">
          <h1 style="font-size: .6rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 800;color: #002FA7;margin-left: .7125rem;margin-top: .4rem;">06</h1>
          <h1 style="font-size: .375rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #000000;margin-left: .7125rem;margin-top: .775rem;">正式订单</h1>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>信息变更</span>
          </li>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>合同管理</span>
          </li>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>订单推送确认</span>
          </li>
        </div>
        <div class="leftRight" style="text-align: left;" v-if="livalue === 7">
          <h1 style="font-size: .6rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 800;color: #002FA7;margin-left: .7125rem;margin-top: .4rem;">07</h1>
          <h1 style="font-size: .375rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #000000;margin-left: .7125rem;margin-top: .775rem;">分配工厂</h1>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>订单分配</span>
          </li>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>订单推送确认</span>
          </li>
        </div>
        <div class="leftRight" style="text-align: left;" v-if="livalue === 8">
          <h1 style="font-size: .6rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 800;color: #002FA7;margin-left: .7125rem;margin-top: .4rem;">08</h1>
          <h1 style="font-size: .375rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #000000;margin-left: .7125rem;margin-top: .5875rem;">订单生产</h1>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>生产状态</span>
          </li>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>生产进度</span>
          </li>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>远程生控</span>
          </li>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>质量管控</span>
          </li>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>工厂实景</span>
          </li>
        </div>
        <div class="leftRight" style="text-align: left;" v-if="livalue === 9">
          <h1 style="font-size: .6rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 800;color: #002FA7;margin-left: .7125rem;margin-top: .4rem;">09</h1>
          <h1 style="font-size: .375rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #000000;margin-left: .7125rem;margin-top: .775rem;">完成订单</h1>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>订单交付</span>
          </li>
          <li>
            <img src="../../../assets/newImg/sanjiao.png" alt="" style="width: .15rem;height: .175rem;">
            <span>订单售后</span>
          </li>
        </div>
        <div style="margin-top: .5875rem;">
          <img src="../../../assets/newImg/computer.png" alt=""  style="width: 4.375rem;height: 5.0125rem;">
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const livalue = ref(1)

const liBtn = (val) => {
  livalue.value = val
}
</script>

<style scoped>
.process {
  margin-top: 1.075rem;
}
.title {
    font-size: .3rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    color: #333333;
    margin-top: .8625rem;
}
.proMain {
  margin: 1.125rem 1.7rem;
  display: flex;
}
.leftPro {
  width: 6rem;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}
.leftPro li {
  width: 1.3rem;
  height: 1.125rem;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
.Num {
  font-size: .375rem;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 800;
  color: #808080;
  margin-top: .1rem;
}
.NumText {
  font-size: .225rem;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  color: #000000;
}
.rightBox {
  width: 8.8rem;
  height: 6.1875rem;
  background: linear-gradient(315deg, #FFF9ED 0%, #E8EFFF 100%);
  opacity: 1;
  margin-left: 1.375rem;
  display: flex;
  box-sizing: border-box;
}
.leftRight {
  width: 5.65rem;
  height: 4.9375rem;
  background: #FFFFFF;
  opacity: 1;
  margin-top: .6125rem;
  margin-left: .65rem;
  padding-bottom: .375rem;
}
.rightBox li {
  margin-left: .7625rem;
  /* margin-top: .375rem; */
  height: .5rem;
  line-height: .5rem;
}
.rightBox li span {
  font-size: .2rem;
}
.active {
  background: #002FA7;
}
aaa {
  color: #fff;
}
</style>
